module.exports = __webpack_public_path__ + "static/media/no-data.9f96a134.svg";